export default {
  lowBalance: 'https://hook.eu2.make.com/o7fdfdnh2rkx2yjkhplerp3pes4ftf9p',
}
